import { useEffect, useState, useContext, useCallback } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from '@sm360/hooks'
import { Button, Input } from '@sm360/ui-library'
import { ListingContext } from '../../configs/listing-view/state.manager'
import Heading from '../heading/Heading'
import { changeUrl } from '../../utils/handle-url.utils'
import ga4Trigger from '../../datalayer/analytics.service'
import dataLayerTags from '../../constants/dataLayerTags'
import { getPathname } from '../../utils/helper.utils'

const FilterSearch = ({ extraClasses }) => {
    const {
        state: {
            filterMetaData,
            dealerInfos: { lang },
            vehicleCriteria,
            hubName,
        },
        addVehicleCriteria,
        dispatch,
    } = useContext(ListingContext)

    const { t } = useTranslation()
    const baseClass = 'il-filterSearch'
    const classNames = clsx(baseClass, extraClasses)

    const [localValue, setLocalValue] = useState(vehicleCriteria?.text || '')

    useEffect(() => {
        setLocalValue(vehicleCriteria?.text || '')
    }, [vehicleCriteria?.text])

    const triggerAnalytics = useCallback((value) => {
        ga4Trigger(dataLayerTags.LAYER_NAVIGATION__FILTERS(getPathname(), 'searchbar'))
        ga4Trigger(dataLayerTags.FILTER_SEARCH(value))
    }, [])

    const handleInputSearch = useCallback(
        (value) => {
            const searchCriteria = { text: value }
            const criteria = addVehicleCriteria(vehicleCriteria, searchCriteria, null, true)
            changeUrl(criteria, filterMetaData, lang, hubName)
            dispatch({ type: 'updateVehicleCriteria', vehicleCriteria: criteria })
            triggerAnalytics(value)
        },
        [vehicleCriteria, filterMetaData, lang, hubName, addVehicleCriteria, dispatch, triggerAnalytics]
    )

    useEffect(() => {
        if (localValue === (vehicleCriteria?.text || '')) return

        const delay = localValue ? 500 : 300
        const handler = setTimeout(() => {
            handleInputSearch(localValue)
        }, delay)

        return () => clearTimeout(handler)
    }, [handleInputSearch, localValue, vehicleCriteria?.text])

    return (
        <div className={classNames}>
            <Heading extraClasses={`${baseClass}__heading heading3`} Tag='p' variant='heading3'>
                {t('filters.search.title')}
            </Heading>
            <div className={`${baseClass}__inputGroup`}>
                <Input
                    className={`${baseClass}__input`}
                    clearable
                    placeholder={t('filters.search.label')}
                    maxChar={30}
                    type='search'
                    onChange={(value) => setLocalValue(value)}
                    value={localValue}
                />
                <Button icon='search' className={`${baseClass}__button`} />
            </div>
        </div>
    )
}

FilterSearch.propTypes = {
    /** Extra classes */
    extraClasses: PropTypes.string,
}

FilterSearch.defaultProps = {
    extraClasses: '',
}

export default FilterSearch
